// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3agG7","footer":"styles_footer__3GnYO"};